import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//V1 Module

// Import Angular Material modules
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';

// Import other libraries
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';

import { AtMentionModule } from '@app/core/_common/at-mention/at-mention.module';
import { PartialsModule } from '@app/layout-sidebar/partials/partials.module';
import { DirectiveModule } from 'v2/modules/shared/directives/directive.module';
import { PipeModule } from 'v2/modules/shared/pipes/pipe.module';
import { FeatureModule } from 'v2/shared/feature/feature.module';

import { LineItemsMultiselectComponent } from './components/line-items-multiselect/line-items-multiselect.component';
import { SkuKitDropdownComponent } from './components/sku-kit-dropdown/sku-kit-dropdown.component';
import { DirectiveV1Module } from './directive-v1.module';

const angularModules = [
  FormsModule,
  ReactiveFormsModule,
  CommonModule,
  TranslateModule,
  RouterModule,
  DragDropModule,
  MatButtonModule,
  MatCheckboxModule,
  MatPaginatorModule,
  MatRadioModule,
  MatTabsModule,
  MatMenuModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatDialogModule,
  MatTooltipModule,
];

const libraryModules = [NgbModule, NgSelectModule, NgxPermissionsModule];

const components = [
  LineItemsMultiselectComponent,
  SkuKitDropdownComponent,
];

const v1Module = [
  FeatureModule,
  AtMentionModule,
  DirectiveV1Module,
  DirectiveModule,
  PartialsModule,
  PipeModule,
];

@NgModule({
  declarations: [...components],
  imports: [...angularModules, ...libraryModules, ...v1Module],
  exports: [...components],
})
export class SharedComponentsV1Module {}
